import 'react';
import './Provider/ThemeContext.js';
import 'classnames';
import { css } from 'emotion';
import { css as css$1 } from '@emotion/core';
import 'emotion-theming';
import '@emotion/styled';
import { a as _taggedTemplateLiteralLoose } from './_rollupPluginBabelHelpers.js';
import './ColorMode/ColorModeContext.js';
import 'lodash/kebabCase';
import 'tinycolor2';
import { t as theme, p as palette, c as borderRadius, e as fontSize } from './getCSSFromStyleObject.js';
import 'lodash/uniq';
import 'reakit/Id';
import 'deepmerge';
import 'lodash/set';
import 'lodash/get';
import 'capsize';
import '@emotion/is-prop-valid';
import './utils/OutsideClickHandler.js';

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n      font-size: ", "rem;\n\n      & {\n        ", ";\n      }\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n      font-size: ", "rem;\n\n      & {\n        ", ";\n      }\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n      & {\n        ", ";\n      }\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n      font-size: ", "rem;\n\n      & {\n        ", ";\n      }\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  & {\n    ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n      & {\n        border-color: ", ";\n        box-shadow: ", " 0px 0px 0px 3px !important;\n      }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  -webkit-appearance: none;\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  color: ", ";\n  width: 100%;\n  padding: 0.4em 0.8em;\n  transition: box-shadow 0.1s ease-in-out 0s, border-color 0.1s, background-color 0.1s;\n\n  &[disabled] {\n    background-color: ", ";\n    box-shadow: unset;\n    color: ", ";\n    cursor: not-allowed;\n\n    & {\n      ", ";\n    }\n  }\n\n  &:focus {\n    outline: unset;\n    z-index: 2;\n    border-color: ", ";\n    box-shadow: ", " 0px 0px 0px 3px !important;\n\n    & {\n      ", ";\n    }\n  }\n\n  &::placeholder {\n    color: ", ";\n\n    & {\n      ", ";\n    }\n  }\n\n  ", "\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  position: relative;\n  width: 100%;\n\n  ", ";\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var TextareaWrapper = function TextareaWrapper(styleProps) {
  return css(_templateObject(), styleProps.size && wrapperSizeProperties(styleProps), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var Textarea = function Textarea(styleProps) {
  return css(_templateObject2(), palette('default')(styleProps), palette('white900', {
    dark: 'gray700'
  })(styleProps), borderRadius('default')(styleProps), palette('text')(styleProps), palette('white700', {
    dark: 'black200'
  })(styleProps), palette('text100')(styleProps), theme(styleProps.themeKey, "styles.disabled")(styleProps), palette('primary')(styleProps), palette('primaryTint')(styleProps), theme(styleProps.themeKey, "styles.focus")(styleProps), palette('gray300')(styleProps), theme(styleProps.themeKey, "styles.placeholder")(styleProps), styleProps.state && css$1(_templateObject3(), palette("" + styleProps.state)(styleProps), palette(styleProps.state + "Tint")(styleProps)), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var TextareaField = function TextareaField(styleProps) {
  return css(_templateObject4(), theme(styleProps.themeKey, "styles.base")(styleProps));
};
function wrapperSizeProperties(styleProps) {
  var properties = {
    small: css$1(_templateObject5(), fontSize('150')(styleProps), theme(styleProps.themeKey, "styles.sizes.small")(styleProps)),
    default: css$1(_templateObject6(), theme(styleProps.themeKey, "styles.sizes.default")(styleProps)),
    medium: css$1(_templateObject7(), fontSize('300')(styleProps), theme(styleProps.themeKey, "styles.sizes.medium")(styleProps)),
    large: css$1(_templateObject8(), fontSize('400')(styleProps), theme(styleProps.themeKey, "styles.sizes.large")(styleProps))
  };
  return properties[styleProps.size];
}

var Textarea_styles = /*#__PURE__*/Object.freeze({
  __proto__: null,
  TextareaWrapper: TextareaWrapper,
  Textarea: Textarea,
  TextareaField: TextareaField,
  wrapperSizeProperties: wrapperSizeProperties
});

export { Textarea_styles as T, TextareaWrapper as a, Textarea as b, TextareaField as c, wrapperSizeProperties as w };
